import { CREATE_DMX_CONTROLLER, CREATE_DMX_CONTROLLER_SUCCESSFUL, CREATE_DMX_CONTROLLER_FAILED } from './actionTypes';

export const createDmxController = (controller) => {
  return {
    type: CREATE_DMX_CONTROLLER,
    payload: { controller },
  };
};

export const createDmxControllerSuccessful = (message) => {
  return {
    type: CREATE_DMX_CONTROLLER_SUCCESSFUL,
    payload: message,
  };
};

export const createDmxControllerFailed = (message) => {
  return {
    type: CREATE_DMX_CONTROLLER_FAILED,
    payload: message,
  };
};
